export class Questionnaire {
  id: string = "";
  label: string = "";
  templateId: string = "";
  createdAt: string = "";
}
